export async function layoutCompletionSource(context) {
  const match = context.matchBefore(/\[#L\s+[\w-]*/)
  if (!match) return null
  if (match.from === match.to && !context.explicit) return null

  const prefix = "[#L "
  // match.text contains the full matched string
  const query = match.text.slice(prefix.length)

  try {
    const res = await fetch(`/api/v1/autocomplete/modules.json?query=${encodeURIComponent(query)}`, {
      headers: {
        "content-type": "application/json"
      }
    })
    const json = await res.json()

    return {
      from: match.from + prefix.length,
      options: json["modules"].map(module => ({
        label: module.alias,
        type: "module"
      }))
    }
  } catch(err) {
    if (err.name !== "AbortError") throw err
  }
}